import axios from 'axios';
import Cookies from 'js-cookie';
import useSWR from 'swr';
import { useToken } from '@/context/useToken';
import { useCartCookie } from '@/helpers/useCartCookie';

import { getApiUrl, getDomain, formatAndThrowApiError } from '@/helpers/api';

export const useSelf = () => {
  const { token } = useToken();
  let urlStr = `${getApiUrl()}/self`;
  if (!token) {
    urlStr = null;
  }
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });
  return swr;
};

export const usePostUser = () => {
  const postUser = async (payload) => {
    try {
      const url = `${getApiUrl()}/user`;
      const response = await axios.post(url, payload);
      Cookies.set(`token`, response.data.token, { domain: getDomain() });
      return response.data.token;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postUser;
};

export const usePutUser = () => {
  const putUser = async (payload) => {
    try {
      const url = `${getApiUrl()}/user`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putUser;
};

export const usePostLogin = () => {
  const { getCartId } = useCartCookie();

  const postUser = async (payload) => {
    const cartId = getCartId();
    try {
      const url = `${getApiUrl()}/login${cartId ? `?cartId=${cartId}` : ''}`;
      const response = await axios.post(url, payload);
      Cookies.set(`token`, response.data.token, { domain: getDomain() });
      return response.data.token;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postUser;
};

export const usePostForgotPassword = () => {
  const postForgotPassword = async (payload) => {
    try {
      const url = `${getApiUrl()}/forgot-password`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postForgotPassword;
};

export const usePutChangePassword = () => {
  const putChangePassword = async (payload) => {
    try {
      const url = `${getApiUrl()}/self/change-password`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putChangePassword;
};

export const usePostResetPassword = () => {
  const postResetPassword = async (resetPasswordToken, payload) => {
    try {
      const url = `${getApiUrl()}/reset-password/${resetPasswordToken}`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postResetPassword;
};

export const usePostUserWithVerificationCode = () => {
  const postUserWithVerificationCode = async (payload) => {
    try {
      const url = `${getApiUrl()}/user/with-verification-code`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postUserWithVerificationCode;
};

export const usePostUserLoginWithCode = () => {
  const { setToken } = useToken();

  const postUserLoginWithCode = async (payload) => {
    try {
      const url = `${getApiUrl()}/user/login-with-code`;
      const response = await axios.post(url, payload);
      setToken(response.data.token);
      Cookies.set(`token`, response.data.token, { domain: getDomain() });
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postUserLoginWithCode;
};
